import { spotifyMonetizationConstants } from '../constants/spotify_monetization';
import { spotifyMonetizationService } from '../services/spotify_monetization';
import { tracksService } from '../services/tracks';
import { spotifyMonetizationFormatter } from '../formatters/spotify_monetization';

export const spotifyMonetizationActions = {
	getSpotifyMonetization,
	getSpotifyMonetizationTotals,
	getSpotifyMonetizationTimeseries,
	getSpotifyMonetizationDates
};

function getSpotifyMonetization(params) {
	const { platform } = params;
	return (dispatch, getState) => {
		dispatch(request());
		return spotifyMonetizationService.getSpotifyMonetization(params)
			.then(
				spotifyMonetization => {
					let data = spotifyMonetizationFormatter.formatSpotifyMonetizationFlat(spotifyMonetization);
					//return tracksService.getMetadata(ids)
					return Promise.resolve()
					.then(metadata => {
						//const tracks = spotifyMonetizationFormatter.formatMetadata(data, metadata.data);
						const tracks = data;
						dispatch(success(tracks));	
						return tracks;
					}) 

					
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_REQUEST, platform } }
	function success(data) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_SUCCESS, data, platform } }
	function failure(error) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_FAILURE, error } }
}

function getSpotifyMonetizationTotals(params) {
	const { platform } = params;
	return (dispatch, getState) => {
		dispatch(request());
		return spotifyMonetizationService.getSpotifyMonetizationTotals(params)
			.then(
				spotifyMonetization => {
					let data = spotifyMonetizationFormatter.formatSpotifyMonetizationTotals(spotifyMonetization);
					dispatch(success(data));	
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TOTALS_REQUEST, platform } }
	function success(data) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TOTALS_SUCCESS, data, platform } }
	function failure(error) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TOTALS_FAILURE, error } }
}

function getSpotifyMonetizationTimeseries(params) {
	const { platform } = params;
	return (dispatch, getState) => {
		dispatch(request());
		return spotifyMonetizationService.getSpotifyMonetizationTimeseries(params)
			.then(
				spotifyMonetization => {
					let data = spotifyMonetizationFormatter.formatSpotifyMonetizationTimeseries(spotifyMonetization);
					dispatch(success(data));	
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TIMESERIES_REQUEST, platform } }
	function success(data) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TIMESERIES_SUCCESS, data, platform } }
	function failure(error) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_TIMESERIES_FAILURE, error } }
}

function getSpotifyMonetizationDates(platform) {
	return (dispatch, getState) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		return spotifyMonetizationService.getSpotifyMonetizationDates(globalFilter, platform)
			.then(
				dates => {
					dates = spotifyMonetizationFormatter.formatSpotifyMonetizationDates(dates);
					dispatch(success(dates));	
					return dates;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_DATES_REQUEST, platform } }
	function success(dates) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_DATES_SUCCESS, dates, platform } }
	function failure(error) { return { type: spotifyMonetizationConstants.GET_SPOTIFY_MONETIZATION_DATES_FAILURE, error } }
}
